var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"progress-bar"},[_c('div',{staticClass:"progress",style:({
      width: `${(_vm.current / _vm.max) * 100}%`,
    })})])
}
var staticRenderFns = []

export { render, staticRenderFns }